import type { Reducer } from 'react';
import type { LastTag, ProductTaggingSearchResult, TagPosition } from '../type';
import type { ProductTaggingState } from './ProductTaggingContext';

export type ProductTaggingAction =
    | { type: 'TOGGLE_TAGGING' }
    | { type: 'TOGGLE_DELETING_TAG'; payload: boolean }
    | { type: 'TOGGLE_ADDING_SUPPLIER'; payload: boolean }
    | { type: 'ADDING_TAG'; payload: TagPosition | undefined }
    | { type: 'ADDING_LAST_ADDED_TAG'; payload: LastTag | undefined }
    | { type: 'RESET_TAGGING_FLAGS' }
    | { type: 'SET_TAGGED_PRODUCTS'; payload: ProductTaggingSearchResult[] }
    | {
          type: 'SET_TAGGED_PROFESSIONALS';
          payload: ProductTaggingSearchResult[];
      };

export const productTaggingReducer: Reducer<
    ProductTaggingState,
    ProductTaggingAction
> = (state, action) => {
    switch (action.type) {
        case 'TOGGLE_TAGGING':
            return {
                ...state,
                isTagging: !state.isTagging,
            };
        case 'TOGGLE_DELETING_TAG':
            return {
                ...state,
                isDeletingTag: action.payload,
            };
        case 'TOGGLE_ADDING_SUPPLIER':
            return {
                ...state,
                isAddingSupplier: action.payload,
            };
        case 'ADDING_TAG':
            return {
                ...state,
                tagPosition: action.payload,
            };
        case 'ADDING_LAST_ADDED_TAG':
            return {
                ...state,
                lastAddedTag: action.payload,
            };
        case 'RESET_TAGGING_FLAGS':
            return {
                ...state,
                lastAddedTag: undefined,
                isAddingSupplier: false,
            };
        case 'SET_TAGGED_PRODUCTS':
            return {
                ...state,
                recentlyTaggedProducts: action.payload,
            };
        case 'SET_TAGGED_PROFESSIONALS':
            return {
                ...state,
                recentlyTaggedProducts: action.payload,
            };
        default:
            throw state;
    }
};
